import { VenteAchatParametreRow } from './parametre-document-settings.service';

/** Valeur par défaut pour `<input type="color">` (hex #rrggbb obligatoire). */
export const DEFAULT_HEX_COLOR = '#134ad3';

/**
 * Convertit une valeur API (hex court/long ou vide) en hex #rrggbb pour `input[type=color]`.
 */
export function toHexColorInputValue(raw: string | null | undefined): string {
    if (raw == null || String(raw).trim() === '') {
        return DEFAULT_HEX_COLOR;
    }
    const s = String(raw).trim();
    if (/^#[0-9A-Fa-f]{6}$/.test(s)) {
        return s.toLowerCase();
    }
    if (/^#[0-9A-Fa-f]{3}$/.test(s)) {
        const h = s.slice(1);
        return (`#${h[0]}${h[0]}${h[1]}${h[1]}${h[2]}${h[2]}`).toLowerCase();
    }
    return DEFAULT_HEX_COLOR;
}

/** API PHP / JSON peut renvoyer 0/1 en nombre ou chaîne */
export function toTinyInt01(v: unknown): 0 | 1 {
    if (v === 1 || v === '1' || v === true) {
        return 1;
    }
    return 0;
}

export function isTruthyTinyInt(v: unknown): boolean {
    return toTinyInt01(v) === 1;
}

/** Base de calcul du prix d'entrée pour le CMUP (facture fournisseur). */
export type BaseCalculPrixAchat = 'produit' | 'document_achat';

export function normalizeBaseCalculPrixAchat(v: unknown): BaseCalculPrixAchat {
    const s = String(v ?? '')
        .toLowerCase()
        .replace(/-/g, '_')
        .trim();
    if (
        s === 'produit' ||
        s === 'fiche_produit' ||
        s === 'article' ||
        s === '1'
    ) {
        return 'produit';
    }
    if (
        s === 'document_achat' ||
        s === 'document' ||
        s === 'ligne' ||
        s === 'doc_achat' ||
        s === '2'
    ) {
        return 'document_achat';
    }
    return 'document_achat';
}

/** Normalise une ligne `vente_achat` après GET / PUT */
export function normalizeVenteAchatRow(raw: Partial<VenteAchatParametreRow> | Record<string, unknown>): VenteAchatParametreRow {
    const r = raw as Partial<VenteAchatParametreRow>;
    const typeId = r.type_document_id != null ? Number(r.type_document_id) : 0;
    const cat = (r.document_category === 'achat' || r.document_category === 'vente' ? r.document_category : 'vente') as 'vente' | 'achat';
    return {
        id: r.id != null ? Number(r.id) : undefined,
        station_id: r.station_id != null ? Number(r.station_id) : undefined,
        type_document_id: typeId,
        document_category: cat,
        aff_montant_totaux: toTinyInt01(r.aff_montant_totaux),
        aff_inf_contact: toTinyInt01(r.aff_inf_contact),
        aff_courte_desp: toTinyInt01(r.aff_courte_desp),
        aff_num_bn_liv: toTinyInt01(r.aff_num_bn_liv),
        note: r.note != null ? String(r.note) : null,
        label: r.label != null ? String(r.label) : null,
        couleur: r.couleur != null ? String(r.couleur) : null,
        date_paiement:
            r.date_paiement === 'mois' || r.date_paiement === 'annee' || r.date_paiement === 'jours'
                ? r.date_paiement
                : 'jours',
        nb_date: (() => {
            const n = r.nb_date as unknown;
            if (n == null || n === '') {
                return null;
            }
            const num = Number(n);
            return Number.isNaN(num) ? null : num;
        })(),
        insr_orig_artcl: toTinyInt01(r.insr_orig_artcl),
        insr_qr_cd: toTinyInt01(r.insr_qr_cd),
        aff_inf: (() => {
            const raw = r as Record<string, unknown>;
            if (raw['aff_inf'] !== undefined && raw['aff_inf'] !== null) {
                return toTinyInt01(raw['aff_inf']);
            }
            return 1;
        })()
    };
}
